/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Vekn_Link_TitleInputs */



/**
* | output |
* | --- |
* | "View on vekn.net" |
*
* @param {Tournament_Vekn_Link_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_vekn_link_title = /** @type {((inputs?: Tournament_Vekn_Link_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Vekn_Link_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir sur vekn.net")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver en vekn.net")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ver em vekn.net")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza su vekn.net")
	return /** @type {LocalizedString} */ ("View on vekn.net")
});